import actions from "./actions";
import {
  dashboardViewActions,
  UpdateUserDetailsActions,
  customLogoutActions
} from "./actions";

const initState = {
  logoutFlag: false,
  idToken: null,
  // userId: null,
  credentials: null,
  status: null,
  error: null,
  // user_role: null,
  // data: null,
  // OTPStatus: null,
  dashboardStatus: false,
  userErrorMessage: null,
  userDataStatus: null,
  userData: null,
  profileData: null,
  userDetails: null,
  // resetPass: false
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    // case actions.LOGIN_REQUEST:
    //
    //   return {
    //     ...state,
    //     error: null,
    //     idToken: null,
    //     credentials: null,
    //     status: null
    //   };

    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        error: null,
        idToken: action.token,
        credentials: action.payload,
        profileData: action.payload.data.token,
        nameAlias: action.nameAlias,
        dpInfo: action.dpInfo,
      };

    case "UPDATE_DP_INFO":
      return {
        ...state,
        dpInfo: action.payload,
      };

    case actions.LOGIN_ERROR:
      return {
        ...state,
        error: action.payload,
        status: action.payload.status,
        credentials: null
      };
    // case actions.SEND_OTP_REQUEST:
    //   //
    //   return {
    //     ...state
    //   };

    // case actions.SEND_OTP_SUCCESS:
    //   //
    //   return {
    //     ...state,
    //     OTPStatus: action.payload.status,
    //     status: action.payload.status
    //   };

    case actions.SEND_OTP_ERROR:
      return {
        ...state,
        // OTPStatus: action.payload,
        // status: action.payload.status,
        error: action.payload
      };

    // case actions.VERIFY_OTP_REQUEST:
    //   //
    //   return {
    //     ...state
    //   };

    // case actions.VERIFY_OTP_SUCCESS:
    //   //
    //   return {
    //     ...state,
    //     resetPass: true,
    //     status: action.payload.status
    //   };

    // case actions.VERIFY_OTP_ERROR:
    //   //

    //   return {
    //     ...state,
    //     OTPStatus: action.payload,
    //     status: action.payload.status,
    //     error: action.payload
    //   };
    case actions.LOGOUT_POPUP:
      return {
        ...state,
        idToken: null,
        // userId: null,
        error: null,
        status: null,
        credentials: null,
        logoutFlag: false,
      };

    case actions.LOGOUT_FLAG_UPDATE:
      return {
        ...state,
        logoutFlag: true,
      };
    case actions.SET_ERROR:
      return {
        error: null
      };

    case dashboardViewActions.VIEW_DASHBOARD_STATUS_TRUE:
      return {
        ...state,
        dashboardStatus: true
      };

    case dashboardViewActions.VIEW_DASHBOARD_STATUS_FALSE:
      return {
        ...state,
        dashboardStatus: false
      };

    // GET USER BY ID
    case UpdateUserDetailsActions.SAVE_USER_DETAILS:
      return {
        ...state,
        isLoading: true,
        userErrorMessage: null,
        userData: null
      };
    case UpdateUserDetailsActions.SAVE_USER_DETAILS_FULFILLED:
      return {
        ...state,
        loading: true,
        isLoading: false,
        profileData: action.payload.data.data,
        userData: action.payload.data,
        userDataStatus: action.payload.status,
        userErrorMessage: null
      };
    case UpdateUserDetailsActions.SAVE_USER_DETAILS_REJECTED:
      return {
        ...state,
        isLoading: false,
        userErrorMessage: action.payload,
        userData: null
      };
    case UpdateUserDetailsActions.SAVE_USER_DETAILS_STATUS:
      return {
        ...state,
        userData: null
      };
    case customLogoutActions.CUSTOM_LOGOUT:
      return {
        ...state,
        error: null
      };
    case customLogoutActions.CUSTOM_LOGOUT_SUCCESS:
      return {
        ...state,
        idToken: null,
        userId: null,
        VerifyOTPToken: null
      };
    case customLogoutActions.CUSTOM_LOGOUT_ERROR:
      return {
        error: action.payload
        //error: payload
      };
    // case customLogoutActions.LOGOUT_UNAUTHORIZED:
    //   return {
    //     ...state,
    //     idToken: null,
    //     // userId: null,
    //     error: action.payload,
    //     status: null,
    //     credentials: null
    //   };

    default:
      return state;
  }
}
